import { hours } from './utils';

/** Les types de pointage qui sont du travail (pas une absence). */
const TRAVAIL = new Set(['normal', 'supp', 'deplacement', '', undefined, null]);

/** « 07:15 » → minutes depuis minuit, ou null. */
function minutes(hhmm) {
  const m = /^(\d{1,2}):(\d{2})/.exec(String(hhmm || ''));
  return m ? +m[1] * 60 + +m[2] : null;
}

/**
 * Le bilan des heures d'un chantier : faites, par employé, et si les horaires
 * du contrat sont respectés.
 *
 * @param {object[]} pointages pointages du chantier (entree, sortie, pause, type, empId, date, onSiteEntree)
 * @param {object[]} employes fiches (heuresJour, heureDebut)
 * @param {{tolerance?: number}} [options] retard toléré à l'arrivée, en minutes (15)
 * @returns {{faites: number, parEmploye: object[], retards: object[], horsChantier: object[]}}
 */
/** « 13.07.2026 » ou « 2026-07-13 » → « 2026-07-13 », pour trier. */
const cleDate = (d) => {
  const m = /^(\d{1,2})\.(\d{1,2})\.(\d{4})/.exec(String(d || ''));
  return m ? m[3] + '-' + m[2].padStart(2, '0') + '-' + m[1].padStart(2, '0') : String(d || '');
};
const plusRecentDabord = (a, b) => cleDate(b.date).localeCompare(cleDate(a.date));

export function bilanHeures(pointages, employes, { tolerance = 15 } = {}) {
  const parEmp = new Map();
  const parJour = new Map();
  const retards = [];
  const horsChantier = [];
  let faites = 0;
  for (const p of pointages || []) {
    if (!TRAVAIL.has(p.type)) continue;
    const h = hours(p.entree, p.sortie, p.pause);
    if (!(h > 0)) continue;
    faites += h;
    const e = (employes || []).find((x) => x.id === p.empId);
    const cle = p.empId ?? p.empNom;
    const ligne = parEmp.get(cle) || {
      empId: p.empId,
      nom: e ? [e.prenom, e.nom].filter(Boolean).join(' ') : p.empNom,
      heures: 0,
      joursAuDela: 0,
    };
    ligne.heures += h;
    parEmp.set(cle, ligne);
    const jour = cle + '|' + p.date;
    parJour.set(jour, { ligne, contrat: +e?.heuresJour || 0, h: (parJour.get(jour)?.h || 0) + h });
    const debut = minutes(e?.heureDebut);
    const arrivee = minutes(p.entree);
    if (debut != null && arrivee != null && arrivee > debut + tolerance) {
      retards.push({ nom: ligne.nom, date: p.date, entree: p.entree });
    }
    if (p.onSiteEntree === false) horsChantier.push({ nom: ligne.nom, date: p.date });
  }
  for (const { ligne, contrat, h } of parJour.values()) {
    if (contrat > 0 && h > contrat + 0.01) ligne.joursAuDela += 1;
  }
  return {
    faites: Math.round(faites * 100) / 100,
    parEmploye: [...parEmp.values()].sort((a, b) => b.heures - a.heures),
    retards: retards.sort(plusRecentDabord),
    horsChantier: horsChantier.sort(plusRecentDabord),
  };
}
